import { render } from "./CharmLevel.vue?vue&type=template&id=70960f2b"
import script from "./CharmLevel.vue?vue&type=script&lang=js"
export * from "./CharmLevel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__